// src/data/mockRolesPermissions.js (NEW FILE)

import { PERMISSIONS, ROLES } from '../utils/permissions';

// Initial mapping - this will be loaded into localStorage if empty
export const initialRolesPermissions = {
  [ROLES.ADMIN]: [
    // Modules
    PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_CUSTOMERS, PERMISSIONS.VIEW_TASKS,
    PERMISSIONS.VIEW_INTERACTIONS, PERMISSIONS.VIEW_REPORTS, PERMISSIONS.VIEW_SETTINGS,
    PERMISSIONS.USER_MANAGEMENT_READ, PERMISSIONS.USER_MANAGEMENT_CREATE,
    PERMISSIONS.USER_MANAGEMENT_UPDATE, PERMISSIONS.USER_MANAGEMENT_DELETE,
    PERMISSIONS.CUSTOMER_READ, PERMISSIONS.CUSTOMER_CREATE, PERMISSIONS.CUSTOMER_UPDATE,
    PERMISSIONS.CUSTOMER_DELETE, PERMISSIONS.CUSTOMER_MERGE,
    PERMISSIONS.TASK_READ, PERMISSIONS.TASK_CREATE, PERMISSIONS.TASK_UPDATE,
    PERMISSIONS.TASK_DELETE,
    PERMISSIONS.INTERACTION_READ, PERMISSIONS.INTERACTION_CREATE,
    PERMISSIONS.COMMUNICATION_SEND
  ],
  [ROLES.MANAGER]: [
    // Modules
    PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_CUSTOMERS, PERMISSIONS.VIEW_TASKS,
    PERMISSIONS.VIEW_INTERACTIONS, PERMISSIONS.VIEW_REPORTS, PERMISSIONS.VIEW_SETTINGS,
    PERMISSIONS.USER_MANAGEMENT_READ, // Read only users
    PERMISSIONS.CUSTOMER_READ, PERMISSIONS.CUSTOMER_CREATE, PERMISSIONS.CUSTOMER_UPDATE, PERMISSIONS.CUSTOMER_MERGE,
    PERMISSIONS.TASK_READ, PERMISSIONS.TASK_CREATE, PERMISSIONS.TASK_UPDATE,
    PERMISSIONS.INTERACTION_READ, PERMISSIONS.INTERACTION_CREATE,
    PERMISSIONS.COMMUNICATION_SEND,
  ],
  [ROLES.AGENT]: [
    // Modules
    PERMISSIONS.VIEW_DASHBOARD, PERMISSIONS.VIEW_CUSTOMERS, PERMISSIONS.VIEW_TASKS,
    PERMISSIONS.VIEW_INTERACTIONS,
    PERMISSIONS.CUSTOMER_READ, PERMISSIONS.CUSTOMER_CREATE, PERMISSIONS.CUSTOMER_UPDATE,
    PERMISSIONS.TASK_READ, PERMISSIONS.TASK_CREATE, PERMISSIONS.TASK_UPDATE,
    PERMISSIONS.INTERACTION_READ, PERMISSIONS.INTERACTION_CREATE,
    PERMISSIONS.COMMUNICATION_SEND,
  ],
};

// You might also want a list of just the role names initially
export const initialRoles = Object.keys(initialRolesPermissions);